<p>test-vjs-player works!</p>

<!-- <app-vjs-player [options]="{autoplay: true, controls: true, sources: [{ src: '/path/to/video.mp4', type: 'video/mp4' }]}"></app-vjs-player> -->

<app-vjs-player [options]="{ fluid: true, aspectRatio: '4:3', autoplay: false, controls: true, sources: [{ src: 'https://vjs.zencdn.net/v/oceans.mp4', type: 'video/mp4' }]}"></app-vjs-player>

